"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulerWrapper = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var RulerWrapper = (function (_super) {
    tslib_1.__extends(RulerWrapper, _super);
    function RulerWrapper(modelData, controls) {
        var _this = _super.call(this, modelData, controls) || this;
        _this.controls.canvas.parentElement.insertBefore(_this.rootElement, _this.controls.canvas);
        return _this;
    }
    RulerWrapper.prototype.getRootClassName = function () { return this.modelData.settings.styles.wrapper.className; };
    ;
    return RulerWrapper;
}(base_1.RulerBase));
exports.RulerWrapper = RulerWrapper;
